module.exports = __webpack_public_path__ + "static/img/wal.30216aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/wal.svg
// module id = nJCH
// module chunks = 0